// extracted by mini-css-extract-plugin
export default {"contentLabel":"entidades-notificaciones-form_contentLabel__YJrEP","upload":"entidades-notificaciones-form_upload__Hd109","button":"entidades-notificaciones-form_button__IhiPL"};